// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import { decodeVertexType } from "./decode-data-type.js";
/**
 * Decodes a vertex format, returning type, components, byte  length and flags (integer, signed, normalized)
 */
export function decodeVertexFormat(format) {
    // Strip the -webgl ending if present
    let webglOnly;
    if (format.endsWith('-webgl')) {
        format.replace('-webgl', '');
        webglOnly = true;
    }
    // split components from type
    const [type_, count] = format.split('x');
    const type = type_;
    const components = (count ? parseInt(count) : 1);
    // decode the type
    const decodedType = decodeVertexType(type);
    const result = {
        type,
        components,
        byteLength: decodedType.byteLength * components,
        integer: decodedType.integer,
        signed: decodedType.signed,
        normalized: decodedType.normalized
    };
    if (webglOnly) {
        result.webglOnly = true;
    }
    return result;
}
//# sourceMappingURL=decode-vertex-format.js.map